import { render } from "./StarIcon.vue?vue&type=template&id=1505208e&ts=true"
import script from "./StarIcon.vue?vue&type=script&lang=ts"
export * from "./StarIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__